export const ICON_MAPPINGS: Record<string, string> = {
  'zuora/customers': 'customers',
  'zuora/collections': 'collect',
  'zuora/commerce': 'commerce',
  'zuora/products': 'book',
  'zuora/billing': 'billing',
  'zuora/payments': 'payments',
  'zuora/payments/paymentsoverview': 'paymentOverview',
  'zuora/payments/connections': 'paymentConnections',
  'zuora/payments/routing': 'paymentRouting',
  'zuora/payments/checkout': 'paymentCheckout',
  'zuora/payments/transactions': 'paymentTransactions',
  'zuora/payments/paymentspayments': 'paymentTransactions', // will be removed in next iteration
  'zuora/payments/paymentlinks': 'paymentLinks',
  'zuora/payments/paymentruns': 'paymentRuns',
  'zuora/payments/paymentschedules': 'paymentSchedules',
  'zuora/payments/retry': 'paymentRetry',
  'zuora/payments/paymentmethods': 'paymentMethods',
  'zuora/payments/refunds': 'refunds',
  'zuora/payments/updaterbatch': 'paymentMethodUpdater',
  'zuora/payments/gatewayreconciliation': 'gatewayReconciliation',
  'zuora/payments/globalpaymentsdashboard': 'globalPaymentsDashboard',
  'zuora/payments/settings': 'paymentSettings',
  'zuora/finance': 'finance',
  'zuora/reporting': 'reporting',
  'zuora/analytics': 'analytics',
  'zuora/myconnect': 'marketplace',
  'zuora/usagemediation': 'architecture',
  'zuora/workflow': 'code',
  'zuora/platform': 'code',
  inbox: 'inbox',
  'zuora/settings': 'settings',
  customise: 'cog',
  'zuora/helpandtraining': 'help',
  'zuora/revpro': 'revenue',
  'zuora/revenue': 'revenue',
  'zuora/revenueonboarding': 'revenue',
  'zuora/customeradmin': 'person',
  dashboard: 'dashboard',
  setups: 'setups',
  policies: 'policies',
  process: 'processAi',
  ssp: 'ssp',
  workbench: 'workbench',
  accounting: 'finance',
  'file upload': 'fileUpload',
  reports: 'reporting',
  'integration hub': 'marketplace',
  'data interface': 'list',
  extension_studio: 'code',
  'zuora/profile': 'custom-avatar',
  forecast: 'insights',
  'zuora/submitfeedback': 'feedback',
};
